import styled from "styled-components";
import { useDataLayerContext } from "../ContextLayer/DataProvider/DataProvider";
import { DictionaryTagEntryType } from "../ContextLayer/DataProvider/types";
import { useEffect, useRef } from "react";
import { useSettingsStorageContext } from "../ContextLayer/SettingsStorageProvider";

const TagSelectorContainerAtom = styled.div<{$darkMode: boolean}>`
    display: flex;
    flex-direction: row;
    // justify-content: center;
    align-items: center;
    // gap: 5px;

    width: 100%;
    height: 40px;

    // border: 1px solid rgb(255 247 234 / ${props => props.$darkMode ? '0' : '48'}%);
    border-radius: 20px;

    box-shadow: 6px 6px 18px rgba(0, 0, 0, 0.07);
    background-color: ${props => props.$darkMode ? 'rgba(0, 0, 0, 0.14)' : 'rgba(255, 255, 255, 0.14)'};
    backdrop-filter: blur(25px);

    padding-left: 8px;
    padding-right: 8px;
    margin: 0px;

    overflow-y: hidden;
    overflow-x: hidden;

    box-sizing: border-box;

    transition: background-color var(--transition-duration-normal), color var(--transition-duration-normal), height var(--transition-duration-normal), border-color var(--transition-duration-normal);

    &:hover {
        // background-color: rgba(254, 215, 180, 0.18);
    }
`

const HardShellAtom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;

    padding: 0px;
    margin: 0px;

    flex-wrap: nowrap;
    white-space: nowrap;

    // width: 150%;
    height: 35px;

    border-radius: 20px;
    box-sizing: border-box;
`

const Tag = styled.div<{$selected: boolean, $darkMode: boolean}>`
    padding: 5px 10px;
    border-radius: 20px;
    white-space: nowrap;
    cursor: pointer;
    background: ${props => props.$selected ? props.$darkMode ? 'rgba(237, 211, 211, 0.52)' : 'rgba(255, 113, 106, 0.4)' : props.$darkMode ? 'rgba(255, 255, 255, 0.04)' : 'rgba(253, 235, 235, 0.35)'};
    color: ${props => props.$selected ? '#ffffffff' : props.$darkMode ? '#e0e0e0' : '#101010'};
    font-size: 0.8rem;

    transition: background-color 300ms;

    &:hover {
        background-color: ${props => props.$selected ? props.$darkMode ? 'rgba(254, 199, 199, 0.74)' : 'rgba(255, 13, 0, 0.4)' : props.$darkMode ? 'rgba(255, 255, 255, 0.16)' : 'rgba(255, 255, 255, 0.55)'}
        // background-color: ${props => props.$selected ? 'rgba(255, 13, 0, 0.6)' : 'rgba(255, 0, 0, 0.3)'};
    }
`

export default function TagSelector() {
    const { dataLayer, setDataLayer } = useDataLayerContext();
    const { settings } = useSettingsStorageContext();

    const tagSelectorContainerRef = useRef<HTMLDivElement>(null);

    const onWheel = (e: WheelEvent) => {
        tagSelectorContainerRef.current?.scrollBy({
            left: e.deltaY > 0 ? 50 : -50,
            behavior: 'smooth'
        });
    }

    useEffect(() => {
        const container = tagSelectorContainerRef.current;
        container?.addEventListener('wheel', onWheel);
        return () => {
            container?.removeEventListener('wheel', onWheel);
        }
    }, []);

    const selectTag = (tag: string) => {
        const newAggregatedTags = (dataLayer?.tags || []).map((t: DictionaryTagEntryType) => {
            let newSelectedValue = false;
            if(t.tag === tag) {
                newSelectedValue = !t.selected;
            }else{
                newSelectedValue = t.selected;
            }

            return {
                tag: t.tag,
                selected: newSelectedValue
            }
        });

        setDataLayer({
            ...dataLayer,
            tags: newAggregatedTags
        });
    }

    return (
        <TagSelectorContainerAtom ref={tagSelectorContainerRef} $darkMode={settings.darkMode}>
            <HardShellAtom>
                {(dataLayer.tags || []).map((tagEntry: DictionaryTagEntryType) => <Tag key={tagEntry.tag} $darkMode={settings.darkMode} $selected={tagEntry.selected} onClick={() => selectTag(tagEntry.tag)}>{tagEntry.tag}</Tag>)}
            </HardShellAtom>
        </TagSelectorContainerAtom>)
}